import type { Type } from '@angular/core';
import type { DashboardGridItem, DashboardWidgetType } from './dashboard-widget-types';
import { DashKpiCollectionWidgetComponent } from './widgets/dash-kpi-collection.widget';
import { DashKpiProjectionWidgetComponent } from './widgets/dash-kpi-projection.widget';
import { DashKpiPendingWidgetComponent } from './widgets/dash-kpi-pending.widget';
import { DashKpiRateWidgetComponent } from './widgets/dash-kpi-rate.widget';
import { DashSalesChartWidgetComponent } from './widgets/dash-sales-chart.widget';
import { DashCollectionTimelineWidgetComponent } from './widgets/dash-collection-timeline.widget';
import { DashCollectionBreakdownWidgetComponent } from './widgets/dash-collection-breakdown.widget';
import { DashUpcomingOverdueWidgetComponent } from './widgets/dash-upcoming-overdue.widget';
import { DashInvoiceStatusWidgetComponent } from './widgets/dash-invoice-status.widget';
import { DashRecentPaymentsWidgetComponent } from './widgets/dash-recent-payments.widget';

export interface DashboardWidgetMeta {
  title: string;
  defaultCols: number;
  defaultRows: number;
  minCols?: number;
  minRows?: number;
  component: Type<unknown>;
}

export const DASHBOARD_WIDGET_REGISTRY: Record<DashboardWidgetType, DashboardWidgetMeta> = {
  'kpi-collection': {
    title: 'KPI — Cobranza en el período',
    defaultCols: 3,
    defaultRows: 3,
    minCols: 2,
    minRows: 2,
    component: DashKpiCollectionWidgetComponent
  },
  'kpi-projection': {
    title: 'KPI — Proyección (vencimientos)',
    defaultCols: 3,
    defaultRows: 3,
    minCols: 2,
    minRows: 2,
    component: DashKpiProjectionWidgetComponent
  },
  'kpi-pending': {
    title: 'KPI — Pendiente por cobrar',
    defaultCols: 3,
    defaultRows: 3,
    minCols: 2,
    minRows: 2,
    component: DashKpiPendingWidgetComponent
  },
  'kpi-rate': {
    title: 'KPI — Tasa de cobranza',
    defaultCols: 3,
    defaultRows: 3,
    minCols: 2,
    minRows: 2,
    component: DashKpiRateWidgetComponent
  },
  'sales-chart': {
    title: 'Ventas / facturación en el tiempo',
    defaultCols: 6,
    defaultRows: 5,
    minCols: 4,
    minRows: 4,
    component: DashSalesChartWidgetComponent
  },
  'collection-timeline': {
    title: 'Cobranza por día',
    defaultCols: 6,
    defaultRows: 5,
    minCols: 4,
    minRows: 4,
    component: DashCollectionTimelineWidgetComponent
  },
  'collection-breakdown': {
    title: 'Desglose cobrado / pendiente',
    defaultCols: 6,
    defaultRows: 4,
    minCols: 3,
    minRows: 3,
    component: DashCollectionBreakdownWidgetComponent
  },
  'upcoming-overdue': {
    title: 'Próximos y vencidos',
    defaultCols: 6,
    defaultRows: 5,
    minCols: 4,
    minRows: 4,
    component: DashUpcomingOverdueWidgetComponent
  },
  'invoice-status': {
    title: 'Facturas por estado',
    defaultCols: 6,
    defaultRows: 5,
    minCols: 4,
    minRows: 4,
    component: DashInvoiceStatusWidgetComponent
  },
  'recent-payments': {
    title: 'Últimos pagos',
    defaultCols: 6,
    defaultRows: 4,
    minCols: 3,
    minRows: 3,
    component: DashRecentPaymentsWidgetComponent
  }
};

export const DASHBOARD_WIDGET_TYPE_ORDER: DashboardWidgetType[] = [
  'kpi-collection',
  'kpi-projection',
  'kpi-pending',
  'kpi-rate',
  'sales-chart',
  'collection-timeline',
  'collection-breakdown',
  'recent-payments',
  'upcoming-overdue',
  'invoice-status'
];

export function defaultDashboardLayout(): DashboardGridItem[] {
  return [
    { id: 'w-kpi-col', widgetType: 'kpi-collection',            cols: 3, rows: 2, y: 0, x: 0 },
    { id: 'w-kpi-proj', widgetType: 'kpi-projection',           cols: 3, rows: 2, y: 0, x: 3 },
    { id: 'w-kpi-pend', widgetType: 'kpi-pending',              cols: 3, rows: 2, y: 0, x: 6 },
    { id: 'w-kpi-rate', widgetType: 'kpi-rate',                 cols: 3, rows: 2, y: 0, x: 9 },

    { id: 'w-sales', widgetType: 'sales-chart',                 cols: 8, rows: 4, y: 2, x: 0 },
    { id: 'w-recent', widgetType: 'recent-payments',            cols: 4, rows: 4, y: 2, x: 8 },

    { id: 'w-timeline', widgetType: 'collection-timeline',      cols: 6, rows: 4, y: 4, x: 0 },
    { id: 'w-break', widgetType: 'collection-breakdown',        cols: 6, rows: 4, y: 4, x: 6 },
    { id: 'w-upcoming', widgetType: 'upcoming-overdue',         cols: 6, rows: 4, y: 8, x: 0 },
    { id: 'w-donut', widgetType: 'invoice-status',              cols: 6, rows: 4, y: 8, x: 6 }
  ];
}
